<mat-card class="compact-overview">
  <mat-card-content>
    <div class="overview-header" fxLayoutAlign="space-between center" fxLayout="row"
         (click)="toggleExpanded()" style="cursor: pointer;">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        <label style="cursor: pointer;">Release Queue Status</label>
        <span class="queue-summary" *ngIf="!expanded && !loading">
          ({{ inFlightItems.length }} in-flight, {{ daydreamItems.length }} daydreaming, {{ upcomingItems.length }} upcoming, {{ recentlyCompletedItems.length }} completed)
        </span>
      </div>
      <button mat-icon-button (click)="refreshData(); $event.stopPropagation();" [disabled]="loading" matTooltip="Refresh">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <!-- Expanded Content -->
    <div *ngIf="expanded && !loading" [@expandCollapse]>
      <!-- Section Buttons -->
      <div class="section-buttons" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px">
        <button mat-stroked-button 
                [class.active]="selectedSection === 'inflight'"
                (click)="selectSection('inflight')"
                fxFlex>
          <mat-icon class="text-info">flight_takeoff</mat-icon>
          <span>In-Flight ({{ inFlightItems.length }})</span>
        </button>
        
        <button mat-stroked-button
                [class.active]="selectedSection === 'daydream'"
                (click)="selectSection('daydream')"
                fxFlex>
          <mat-icon class="text-info">auto_awesome</mat-icon>
          <span>Daydreaming ({{ daydreamItems.length }})</span>
        </button>

        <button mat-stroked-button 
                [class.active]="selectedSection === 'upcoming'"
                (click)="selectSection('upcoming')"
                fxFlex>
          <mat-icon class="text-warning">schedule</mat-icon>
          <span>Upcoming ({{ upcomingItems.length }})</span>
        </button>
        
        <button mat-stroked-button 
                [class.active]="selectedSection === 'completed'"
                (click)="selectSection('completed')"
                fxFlex>
          <mat-icon class="text-success">check_circle</mat-icon>
          <span>Completed ({{ recentlyCompletedItems.length }})</span>
        </button>
      </div>

      <!-- Section Content -->
      <div class="section-content-area" *ngIf="selectedSection" [@slideIn]>
      
        <!-- In-Flight Items Content -->
        <div *ngIf="selectedSection === 'inflight'" class="section-content-full">
          <h4 class="section-title">
            <mat-icon class="text-info">flight_takeoff</mat-icon>
            Currently Rendering
          </h4>
          <ng-container *ngFor="let item of inFlightItems; let i = index; trackBy: trackByItemId">
            <mat-card class="contrast mat-card-inline-sm item-card-release" 
              (click)="navigateToReleaseItem(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5px">
                <div fxFlex="80" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
                  <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                      <strong matTooltip="Home">{{ item.home || 'Unknown' }}</strong>
                      <div *ngIf="item?.releaseStatus != null" class="chart-select-color" 
                        [style.background-color]="getStatusInfo(item.releaseStatus).color" 
                        [matTooltip]="'Status: ' + getStatusInfo(item.releaseStatus).text"></div>
                    </div>
                    <small class="text-primary" matTooltip="Master File">{{ item.masterFile || '' }}</small>
                    <span *ngIf="item?.options" [fxHide.lt-sm]="true">></span>
                    <small class="text-primary" matTooltip="Options" *ngIf="item?.options">{{ item.options }}</small>
                    <span [fxHide.lt-sm]="true">></span>
                    <small class="text-primary" matTooltip="Style Template">{{ item.styleTemplate || '' }}</small>
                    <span *ngIf="item?.productName !== undefined" [fxHide.lt-sm]="true">></span>
                    <small *ngIf="item?.productName !== undefined" [style.color]="getProductColour(item.productName)">{{ productNames[item.productName] }}</small>
                  </div>
                </div>
                <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="16px">
                  <small *ngIf="item.dateCreated" class="text-muted">Started: {{ item.dateCreated | date:'short' }}</small>
                  <mat-icon class="product-icon" *ngIf="item.productName !== undefined" 
                    [style.color]="getProductColour(item.productName)"
                    [matTooltip]="productNames[item.productName]">
                    {{ getProductIcon(item.productName) }}
                  </mat-icon>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
          <mat-card class="empty-state" *ngIf="inFlightItems.length === 0">
            <mat-card-content>
              <p class="text-muted">No items currently being rendered</p>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Daydreams being generated: never a renderer's work -->
        <div *ngIf="selectedSection === 'daydream'" class="section-content-full">
          <h4 class="section-title">
            <mat-icon class="text-info">auto_awesome</mat-icon>
            Daydreams Being Generated
          </h4>
          <ng-container *ngFor="let item of daydreamItems; let i = index; trackBy: trackByItemId">
            <mat-card class="contrast mat-card-inline-sm item-card-release"
              (click)="navigateToReleaseItem(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5px">
                <div fxFlex="80" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
                  <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                      <strong matTooltip="Home">{{ item.home || 'Unknown' }}</strong>
                      <div *ngIf="item?.releaseStatus != null" class="chart-select-color"
                        [style.background-color]="getStatusInfo(item.releaseStatus).color"
                        [matTooltip]="'Status: ' + getStatusInfo(item.releaseStatus).text"></div>
                    </div>
                    <small class="text-primary" matTooltip="Master File">{{ item.masterFile || '' }}</small>
                    <span *ngIf="item?.options" [fxHide.lt-sm]="true">></span>
                    <small class="text-primary" matTooltip="Options" *ngIf="item?.options">{{ item.options }}</small>
                    <span [fxHide.lt-sm]="true">></span>
                    <small class="text-primary" matTooltip="Style Template">{{ item.styleTemplate || '' }}</small>
                  </div>
                </div>
                <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="16px">
                  <small *ngIf="item.dateUpdated" class="text-muted">Started: {{ item.dateUpdated | date:'short' }}</small>
                  <mat-icon class="product-icon text-info" matTooltip="Daydream">auto_awesome</mat-icon>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
          <mat-card class="empty-state" *ngIf="daydreamItems.length === 0">
            <mat-card-content>
              <p class="text-muted">No Daydreams being generated</p>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Upcoming Items Content -->
        <div *ngIf="selectedSection === 'upcoming'" class="section-content-full">
          <h4 class="section-title">
            <mat-icon class="text-warning">schedule</mat-icon>
            Queued for Rendering
          </h4>
          <ng-container *ngFor="let item of upcomingItems; let i = index; trackBy: trackByItemId">
            <mat-card class="contrast mat-card-inline-sm item-card-release" 
              (click)="navigateToReleaseItem(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5px">
                <div fxFlex="5" class="queue-number">#{{ i + 1 }}</div>
                <div fxFlex="75" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
                  <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                      <strong matTooltip="Home">{{ item.home || 'Unknown' }}</strong>
                      <div *ngIf="item?.releaseStatus != null" class="chart-select-color" 
                        [style.background-color]="getStatusInfo(item.releaseStatus).color" 
                        [matTooltip]="'Status: ' + getStatusInfo(item.releaseStatus).text"></div>
                    </div>
                    <small [class]="getStatusInfo(item.releaseStatus).class" matTooltip="Master File">{{ item.masterFile || '' }}</small>
                    <span *ngIf="item?.options" [fxHide.lt-sm]="true">></span>
                    <small [class]="getStatusInfo(item.releaseStatus).class" matTooltip="Options" *ngIf="item?.options">{{ item.options }}</small>
                    <span [fxHide.lt-sm]="true">></span>
                    <small [class]="getStatusInfo(item.releaseStatus).class" matTooltip="Style Template">{{ item.styleTemplate || '' }}</small>
                    <span *ngIf="item?.productName !== undefined" [fxHide.lt-sm]="true">></span>
                    <small *ngIf="item?.productName !== undefined" [style.color]="getProductColour(item.productName)">{{ productNames[item.productName] }}</small>
                  </div>
                </div>
                <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="16px">
                  <small [class]="getStatusInfo(item.releaseStatus).class">{{ getStatusInfo(item.releaseStatus).text }}</small>
                  <mat-icon class="product-icon" *ngIf="item.productName !== undefined" 
                    [style.color]="getProductColour(item.productName)"
                    [matTooltip]="productNames[item.productName]">
                    {{ getProductIcon(item.productName) }}
                  </mat-icon>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
          <mat-card class="empty-state" *ngIf="upcomingItems.length === 0">
            <mat-card-content>
              <p class="text-muted">No items in the queue</p>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Recently Completed Content -->
        <div *ngIf="selectedSection === 'completed'" class="section-content-full">
          <h4 class="section-title">
            <mat-icon class="text-success">check_circle</mat-icon>
            Recently Completed (Last {{ recentlyCompletedHours }} hours)
          </h4>
          <ng-container *ngFor="let item of recentlyCompletedItems; let i = index; trackBy: trackByItemId">
            <mat-card class="contrast mat-card-inline-sm item-card-release" 
              (click)="navigateToReleaseItem(item)">
              <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5px">
                <div fxFlex="80" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
                  <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                      <strong matTooltip="Home">{{ item.home || 'Unknown' }}</strong>
                      <div *ngIf="item?.releaseStatus != null" class="chart-select-color" 
                        [style.background-color]="getStatusInfo(item.releaseStatus).color" 
                        [matTooltip]="'Status: ' + getStatusInfo(item.releaseStatus).text"></div>
                    </div>
                    <small class="text-success" matTooltip="Master File">{{ item.masterFile || '' }}</small>
                    <span *ngIf="item?.options" [fxHide.lt-sm]="true">></span>
                    <small class="text-success" matTooltip="Options" *ngIf="item?.options">{{ item.options }}</small>
                    <span [fxHide.lt-sm]="true">></span>
                    <small class="text-success" matTooltip="Style Template">{{ item.styleTemplate || '' }}</small>
                    <span *ngIf="item?.productName !== undefined" [fxHide.lt-sm]="true">></span>
                    <small *ngIf="item?.productName !== undefined" [style.color]="getProductColour(item.productName)">{{ productNames[item.productName] }}</small>
                  </div>
                </div>
                <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="10px">
                  <div fxLayoutAlign="end center" fxLayout="row" fxLayoutAlign.lt-sm="center center">
                    <small *ngIf="item.dateUpdated" class="text-success">{{ item.dateUpdated | date:'short' }}</small>
                    <!-- View Links for Completed Items Only -->
                    <button *ngIf="(item?.productName === productNames.Panorama || item?.productName === productNames.RayTracedDraft || item?.productName === productNames.RayTraced || item?.productName === productNames.RayTracedPlus) && item?.latestVersion"
                            mat-icon-button 
                            color="primary"
                            (click)="openLinkInNewWindow($event, '/situ-view', { id: item.latestVersion })"
                            matTooltip="View in situVIEW">
                      <mat-icon>panorama</mat-icon>
                    </button>
                    <button *ngIf="(item?.productName === productNames.Panorama || item?.productName === productNames.RayTracedDraft || item?.productName === productNames.RayTraced || item?.productName === productNames.RayTracedPlus) && item?.rayTracedDraftVersion"
                            mat-icon-button
                            color="primary"
                            (click)="openLinkInNewWindow($event, '/situ-view', { id: item.rayTracedDraftVersion })"
                            matTooltip="View draft in situVIEW">
                      <mat-icon>2k_plus</mat-icon>
                    </button>
                    <button *ngIf="item?.productName === productNames.Facade && item?.latestVersion"
                            mat-icon-button 
                            color="primary"
                            (click)="openLinkInNewWindow($event, '/situ-facade', { id: item.latestVersion })"
                            matTooltip="View in situFACADE">
                      <mat-icon>image</mat-icon>
                    </button>
                    <button *ngIf="item?.productName === productNames.Plan && item?.latestVersion" 
                            mat-icon-button 
                            color="primary"
                            (click)="openLinkInNewWindow($event, '/situ-plan-readonly', { id: item.latestVersion })"
                            matTooltip="View in situPLAN">
                      <mat-icon>foundation</mat-icon>
                    </button>
                    <button *ngIf="item?.productName === productNames.Render && item?.latestVersion" 
                            mat-icon-button 
                            color="primary"
                            (click)="openLinkInNewWindow($event, '/situ-render-readonly', { id: item.latestVersion })"
                            matTooltip="View in situRENDER">
                      <mat-icon>photo_camera</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
          <mat-card class="empty-state" *ngIf="recentlyCompletedItems.length === 0">
            <mat-card-content>
              <p class="text-muted">No items completed in the last {{ recentlyCompletedHours }} hours</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>